import { SET_IS_FETCHING_CHANNELS } from './actionTypes';

export function setIsFetchingChannels(value) {
  return {
    type: SET_IS_FETCHING_CHANNELS,
    payload: value,
  };
}
